import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/polymarket/$eventId")({
  beforeLoad: () => {
    throw redirect({ to: "/prediction-markets", replace: true });
  },
});
